import { render, staticRenderFns } from "./ApuracaoAcaoDetalhesNova.vue?vue&type=template&id=6bbd6306"
import script from "./ApuracaoAcaoDetalhesNova.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoDetalhesNova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports